// extracted by mini-css-extract-plugin
export default {"popoverBox":"MoreOptions_popoverBox__bYmcT"};